<template>
  <div class="animated">
    <h3>
      Analytes
    </h3>

    <analyte-table
      :analytes="analytes"
      :show_columns="[
        'name',
        'abbrev',
      ]"
    />
  </div>
</template>

<script>
import AnalyteTable from '@/components/lab/analyte/AnalyteTable'

export default {
  name: "SampleAnalyteTable",
  components: {
    AnalyteTable
  },
  props: {
    trigger_approval_all: {
      type: Boolean,
      default: false
    },
    analytes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sample_id: this.$route.params.sample_id || null
    };
  }
};
</script>
